"use strict";

/* A service / model */

_BannerFlowApp.factory("Utils", function ($rootScope, AuthInfo, $state, $stateParams, Cookie) {
    return {
        GetObjectTypeName: function (type) {
            switch (type) {
                case $rootScope.OBJECT_TYPE_CREATIVESET:
                    return "creative set";
                case $rootScope.OBJECT_TYPE_FEED:
                    return "feed";
                case $rootScope.OBJECT_TYPE_LANDINGPAGE:
                    return "landing page";
            }
        },
        GoHome: function () {
            let state = "";

            switch (AuthInfo.LoggedInUser.defaultView) {
                case 1:
                    window.open(
                        "/v2/{0}/{1}/{2}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug,
                            "creative-sets"
                        ),
                        "_self"
                    );
                    return;
                case 2:
                    state = "root.landingpages";
                    break;
                case 4:
                    state = "root.feeds";
                    break;
                case 5:
                    window.open(
                        "/v2/{0}/{1}/{2}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug,
                            "analytics"
                        ),
                        "_self"
                    );
                    return;
                case 6:
                    window.open(
                        "/v2/{0}/{1}/{2}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug,
                            "campaigns/all"
                        ),
                        "_self"
                    );
                    return;
                default:
                    window.open(
                        "/v2/{0}/{1}/{2}".format(
                            AuthInfo.LoggedInUser.currentAccount.slug,
                            AuthInfo.LoggedInUser.currentBrand.slug,
                            "creative-sets"
                        ),
                        "_self"
                    );
                    return;
            }

            Cookie.Create("newLogin", "true");

            $state.go(state, $stateParams, { reload: true, inherit: false, notify: true });
        },
        GotoObject: function (type, slug) {
            switch (type) {
                case $rootScope.OBJECT_TYPE_FEED:
                    $state.go("root.feeds.feed", { feedId: slug });
                    return;
            }
        },
        GetV2BaseUrl: function () {
            return "/v2/{0}/{1}/".format(
                AuthInfo.LoggedInUser.currentAccount.slug,
                AuthInfo.LoggedInUser.currentBrand
                    ? AuthInfo.LoggedInUser.currentBrand.slug
                    : AuthInfo.LoggedInUser.currentAccount.brands[0].slug
            );
        },
        GotoV2Url: function (page, newWindow) {
            const url = this.GetV2BaseUrl() + page;
            if (newWindow) {
                window.open(url, "_blank");
            } else {
                if (this.CheckIfRootScopeIsDirty()) {
                    if (this.ConfirmAndNavigate()) {
                        window.location = url;
                    }
                } else {
                    window.location = url;
                }
            }
        },

        getAnalyticsUrl() {
            switch (window.location.host) {
                case "localhost:49560":
                    return "https://localhost:5007";
                case "sandbox-app.bannerflow.com":
                    return "https://sandbox-app.bannerflow.com/analytics";
                case "sandbox-b2.bannerflow.com":
                    return "https://sandbox-app.bannerflow.com/analytics";
                case "app.bannerflow.com":
                    return "https://app.bannerflow.com/analytics";
                case "b2.bannerflow.com":
                    return "https://app.bannerflow.com/analytics";
                default:
                    return "";
            }
        },

        GotoAnalyticsCustom: function (page) {
            var url = this.getAnalyticsUrl();
            window.location.href = `${url}/${AuthInfo.LoggedInUser.currentAccount.slug}/${AuthInfo.LoggedInUser.currentBrand.slug}/${page}`;
        },

        GotoAnalytics: function () {
            var url = this.getAnalyticsUrl();
            window.location.href = `${url}/${AuthInfo.LoggedInUser.currentAccount.slug}/${AuthInfo.LoggedInUser.currentBrand.slug}`;
        },

        GotoV2BrandSettings: function (page, brand, newWindow) {
            if (!brand) {
                brand = AuthInfo.LoggedInUser.currentBrand
                    ? AuthInfo.LoggedInUser.currentBrand.slug
                    : AuthInfo.LoggedInUser.currentAccount.brands[0].slug;
            }

            var url = "/v2/{0}/{1}/settings/brand/{1}/{2}".format(
                AuthInfo.LoggedInUser.currentAccount.slug,
                brand,
                page
            );

            if (newWindow) {
                window.open(url, "_blank");
            } else {
                if (this.CheckIfRootScopeIsDirty()) {
                    if (this.ConfirmAndNavigate()) {
                        window.location = url;
                    }
                } else {
                    window.location = url;
                }
            }
        },
        GotoV2Settings: function (view, target, accountSlug) {
            target = target || "_self";

            var brand = AuthInfo.LoggedInUser.currentBrand
                ? AuthInfo.LoggedInUser.currentBrand.slug
                : AuthInfo.LoggedInUser.currentAccount.brands[0].slug;

            var accountSlug = accountSlug ? accountSlug : AuthInfo.LoggedInUser.currentAccount.slug;

            if (this.CheckIfRootScopeIsDirty()) {
                if (this.ConfirmAndNavigate()) {
                    window.open(
                        "/v2/{0}/{1}/settings/account/{2}".format(accountSlug, brand, view),
                        target
                    );
                }
            } else {
                window.open(
                    "/v2/{0}/{1}/settings/account/{2}".format(accountSlug, brand, view),
                    target
                );
            }
        },
        // Some helper functions to tackle unsaved changes when routing to external urls, as Eventmanager.js doesn't handle this scenario
        CheckIfRootScopeIsDirty: function () {
            if ($rootScope.feedIsDirty) {
                return true;
            } else {
                return false;
            }
        },

        ConfirmAndNavigate: function () {
            if (
                confirm("You have unsaved changes. If you leave this view your changes will be lost.")
            ) {
                $rootScope.feedIsDirty = false;
                return true;
            } else {
                event.preventDefault();
                return false;
            }
        }
    };
});
